// extracted by mini-css-extract-plugin
module.exports = {"s_container":"EmployeeLayout_s_container__3ZvPc","main":"EmployeeLayout_main__3NFaK","content":"EmployeeLayout_content__1HBUe","page":"EmployeeLayout_page__GxFSO"};